import styled from 'styled-components';
import { Container } from '$app/shared/components/Container';
import { Title } from '$app/shared/components/Header';

export const ContainerStyled = styled(Container)`
  .ant-tabs-content{
    padding: 20px 20px;
    background: white;
  }
  .ant-tabs-bar{
  	margin-bottom: 0;
  	margin-top: 15px;
  	border-bottom: 0;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab{
	border: 0;
	border-radius: 0;
	border-bottom: 0;
	height: auto;
	padding: 8px 25px;
	text-align: center;
	font-size: 15px;
	font-weight: 600;
	color: #a0a0a0;
  position: relative;
    top: -5px;

	&.ant-tabs-tab-active{
	   color: #646464;
	}
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container{
  	height: auto;
  }
  .ant-tabs-tabpane{
  	background: white;
  	padding: 20px;

  	h2 {
	   margin-top: 0px;
	   font-size: 15px;
	   }
  }

`;


export const TitleStyled = styled(Title)`
   margin-top: 13px;
`;

